import { useEffect, useState } from "react";
import { ContainerInputSignInPage } from "./SignInFormStyles.styled";
import { logIn } from "../../../Redux/Auth/operations";
import { useNavigate } from "react-router-dom";
import { useTogglePassword } from "../../../Components/secure/PasswordHook";
import { EmailUserIcon } from "../../../Components/Public/WelcomePage/Header/SignUpModel/setPublicIcons";
import { ButtonPasswordIcon, ErrorTextUser, SubmitFormButton, TextInput } from "../../../Components/Public/WelcomePage/Header/SignUpModel/SignUpModelStyles.styled";
import { FormErrorsSignIn } from "../../../Types/TypeErrors";
import {
    SignInButtonForgotPassword,
    SignInForgotPasswordContainer,
    SignInListItem,
    SignInModelContainer
} from "../../../Components/Public/WelcomePage/Header/SignInModel/SignInModelStyles.styled";
import { useAppDispatch } from "../../../Redux/store";
import useAuth from "../../../Redux/useAuth";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";

export const SignInForm = () => {
    const { t } = useLanguageContext();
    const [emailUserSignIn, setEmailUserSignIn] = useState(() => {
        const saved = localStorage.getItem("form-data-signIn");
        return saved ? JSON.parse(saved).email || "" : "";
    });
    const [passwordUser, setPasswordUser] = useState("");
    const [formErrorsSignInModel, setFormErrorsSignUpModel] = useState<FormErrorsSignIn>({});
    const [hasTriedSubmit, setHasTriedSubmit] = useState(false);
    const dispatch = useAppDispatch();
    const enterPassword = useTogglePassword();
    const router = useNavigate();
    const { user } = useAuth();

    const SignInUser = async (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
        setHasTriedSubmit(true);

        const form = evt.currentTarget;
        const formData = new FormData(form);
        const email = formData.get("email") as string;
        const password = formData.get("password") as string;

        const formDataUser = {
            email: emailUserSignIn.trim(),
            password: passwordUser.trim(),
        };

        localStorage.setItem("form-data-signIn", JSON.stringify(formDataUser));

        try {
            // ✅ Отримуємо дані користувача з unwrap()
            const result = await dispatch(logIn({ email, password })).unwrap();

            // ✅ Повністю очищаємо форму та localStorage
            setEmailUserSignIn("");
            setPasswordUser("");
            clearLocalStorage("form-data-signIn");

            // ✅ Редірект виконуємо за результатом, а не за старим user з Redux
            if (result?.name) {
                router(`/home-page/${result.name.toLowerCase()}`, {
                    state: { openQRCodeModal: true },
                });
            }
        } catch (err) {
            console.log("Unwrapped error:", err);

            if (typeof err === "object" && err !== null) {
                const typedError = err as FormErrorsSignIn;
                setFormErrorsSignUpModel(typedError);
            }
        }
    };

    const clearLocalStorage = (nameKey: string) => {
        localStorage.removeItem(nameKey);
    }
    
    useEffect(() => {

        localStorage.getItem("form-data-signIn");

        if (user?.name) {
            router(`/home-page/${user?.name?.toLowerCase()}`);
            clearLocalStorage("form-data-signIn");
        }
        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.name, emailUserSignIn, passwordUser])

        return (
            <>
                <SignInModelContainer>

                    <form onSubmit={SignInUser}>
                        <ul>
                            <SignInListItem>
                                <ContainerInputSignInPage className={formErrorsSignInModel.email && hasTriedSubmit ? "error-animation-input" : ""}>
                                    <TextInput
                                        name="email"
                                        type="email"
                                        placeholder={t("publicTranslate.FormsAndModel.ModelSignIn.InputEmail")}
                                        onChange={(evt) => {
                                            setEmailUserSignIn(evt.target.value);
                                        }}
                                        value={emailUserSignIn} />
                                    <EmailUserIcon />
                                </ContainerInputSignInPage>
                                <ErrorTextUser className={formErrorsSignInModel.email && hasTriedSubmit ? "error-animation" : ""}>
                                    {formErrorsSignInModel.email}
                                </ErrorTextUser>
                            </SignInListItem>
                            <SignInListItem>
                                <ContainerInputSignInPage className={formErrorsSignInModel.password && hasTriedSubmit ? "error-animation-input" : ""}>
                                    <TextInput 
                                        name="password"
                                        type={enterPassword.type}
                                        placeholder={t("publicTranslate.FormsAndModel.ModelSignIn.InputPassword")}
                                        onChange={(evt) => {
                                            setPasswordUser(evt.target.value);
                                        }}
                                        value={passwordUser}
                                    />
                                    <ButtonPasswordIcon type="button" onClick={enterPassword.toggle}>
                                        {enterPassword.icon}
                                    </ButtonPasswordIcon>
                                </ContainerInputSignInPage>
                                <ErrorTextUser className={formErrorsSignInModel.password && hasTriedSubmit ? "error-animation" : ""}>
                                    {formErrorsSignInModel.password}
                                </ErrorTextUser>
                            </SignInListItem>
                        </ul>
                        <SignInForgotPasswordContainer>
                            <SignInButtonForgotPassword type="button">
                                {t("publicTranslate.FormsAndModel.ModelSignIn.ButtonForgotPassword")}
                            </SignInButtonForgotPassword>
                        </SignInForgotPasswordContainer>
                        <SubmitFormButton type="submit" value={t("publicTranslate.FormsAndModel.ModelSignIn.ButtonSignIn")} />
                    </form>
                </SignInModelContainer>
            </>
        )
}
